import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import {
  CustomReportDebugAgentRunSchema,
  CustomReportDebugRevisionSchema,
} from "./custom-report-debug-schema";

export const getCustomReportDebugHistory = unaryRpc({
  name: "getCustomReportDebugHistory" as const,
  input: z.object({ id: z.string().trim().min(1) }),
  output: z.object({
    agentRuns: z.array(CustomReportDebugAgentRunSchema),
    revisions: z.array(CustomReportDebugRevisionSchema),
  }),
});

export type GetCustomReportDebugHistoryOutput = z.infer<
  typeof getCustomReportDebugHistory.output
>;
